import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
} from "../../../util/varios";
import "react-tabs/style/react-tabs.css";
import TablaIndole from "./tablaIndole";
import moment from "moment";
import TablaTributaria from "./tablaDatosTributarios";
import TablaDeudaLicores from "./tablaDeudaLicores";
import TablaHistoricoLicores from "./tablaHistoricoLicores";
import axios from "axios";
import { Dimmer } from "../../spinner";
import { Input, Textarea } from "../../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";

export const ModalContribuyenteLicores = (props) => {
  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [activate, setActivate] = useState(false);
  const txtCodigoCiu = useRef();
  const txtAlicuota = useRef();
  const txtDescripcionActi = useRef();
  const txtAnios = useRef();
  const txtMinimo = useRef();
  const txtActualizada = useRef();
  const txtCodActividad = useRef();
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const txtRitm = useRef();
  const txtId = useRef();
  const txtPermiso = useRef();
  const txtLicencia = useRef();
  const txtRif = useRef();
  const txtDenominacion = useRef();
  const txtDireccion = useRef();
  const txtTlf = useRef();
  const txtFechIns = useRef();
  const txtCedRep = useRef();
  const txtNomRep = useRef();
  const txtDirecRep = useRef();
  const txtTlfRep = useRef();
  const txtcelRep = useRef();
  const txtEducacional = useRef();
  const txtCuartel = useRef();
  const txtPenal = useRef();
  const txtDeportivo = useRef();
  const txtTemplo = useRef();
  const txtCorrecional = useRef();
  const txtHospital = useRef();
  const txtCarretera = useRef();
  const txtCopas = useRef();
  const txtMercado = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (mensaje.texto == "registro modificado correctamente.") {
      props.onHideCancela();
    }
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      if (event.target.id === "inputCodigo") {
        txtCodActividad.current.focus();
      } else if (event.target.id === "inputCodigoActi") {
        txtCodigoCiu.current.focus();
      } else if (event.target.id === "inputCodigoCiu") {
        txtAnios.current.focus();
      } else if (event.target.id === "inputAnio") {
        txtDescripcionActi.current.focus();
      } else if (event.target.id === "inputDescripcion") {
        txtAlicuota.current.focus();
      } else if (event.target.id === "inputActualizada") {
        btnAcepta.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      return false;
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      if (event.which === 13) {
        if (event.target.id === "inputAlicuota") {
          txtMinimo.current.focus();
        } else if (event.target.id === "inputMinimo") {
          txtActualizada.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const salir = () => {
    props.onHideCancela();
  };

  const actualizarLicores = () => {
    let endpoint = `${op.conexion}/api/licores/actuaizarlicores`;
    let body;

    setActivate(true);

    body = {
      idcome: parseInt(txtId.current.value),
      permi: txtPermiso.current.value,
      licen: txtLicencia.current.value,
      educ:
        txtEducacional.current.value === ""
          ? 0.0
          : txtEducacional.current.value
              .trim()
              .replace(/\./g, "")
              .replace(",", "."),
      cuart:
        txtCuartel.current.value === ""
          ? 0.0
          : txtCuartel.current.value
              .trim()
              .replace(/\./g, "")
              .replace(",", "."),
      pen:
        txtPenal.current.value === " "
          ? 0.0
          : txtPenal.current.value.trim().replace(/\./g, "").replace(",", "."),
      depor:
        txtDeportivo.current.value === ""
          ? 0.0
          : txtDeportivo.current.value
              .trim()
              .replace(/\./g, "")
              .replace(",", "."),
      temp:
        txtTemplo.current.value === ""
          ? 0.0
          : txtTemplo.current.value.trim().replace(/\./g, "").replace(",", "."),
      correc:
        txtCorrecional.current.value === ""
          ? 0.0
          : txtCorrecional.current.value
              .trim()
              .replace(/\./g, "")
              .replace(",", "."),
      hospi:
        txtHospital.current.value === ""
          ? 0.0
          : txtHospital.current.value
              .trim()
              .replace(/\./g, "")
              .replace(",", "."),
      carret:
        txtCarretera.current.value === ""
          ? 0.0
          : txtCarretera.current.value
              .trim()
              .replace(/\./g, "")
              .replace(",", "."),
      copa:
        txtCopas.current.value === ""
          ? 0.0
          : txtCopas.current.value.trim().replace(/\./g, "").replace(",", "."),
      merca:
        txtMercado.current.value === ""
          ? 0.0
          : txtMercado.current.value
              .trim()
              .replace(/\./g, "")
              .replace(",", "."),
    };

    console.log(body);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "registro modificado correctamente.",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setDeshabilitado(props.deshabilitado);
        setOperacion(props.operacion);
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex align-items-center justify-content-between azulGradiant rounded-top">
        <h3 className="m-0 fw-bold text-light">
          {operacion === 1
            ? "Agregar Estado Cuenta."
            : operacion === 2
            ? "Editar Estado Cuenta."
            : operacion === 3
            ? "Eliminar Estado Cuenta."
            : "Registro Contribuyente de Rentas de Licores."}
        </h3>
        <a
          type="button"
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={salir}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <div>
          <ul className="nav mb-2" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link active bg-blue-100 text-light"
                id="datosTributarios"
                data-bs-toggle="tab"
                data-bs-target="#tributarios"
                type="button"
                role="tab"
                aria-controls="tributarios"
                aria-selected="true"
              >
                Registro de Rentas de Licores
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-200 text-light"
                disabled={
                  operacion === 1 || operacion === 3 ? true : deshabilitado
                }
                id="deuda-tab"
                data-bs-toggle="tab"
                data-bs-target="#deuda"
                type="button"
                role="tab"
                aria-controls="deuda"
                aria-selected="false"
              >
                Indole del Expendio
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-300 text-light"
                disabled={
                  operacion === 1 || operacion === 3 ? true : deshabilitado
                }
                id="hist-tab"
                data-bs-toggle="tab"
                data-bs-target="#historico"
                type="button"
                role="tab"
                aria-controls="historico"
                aria-selected="false"
              >
                Datos Tributarios
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-400 text-light"
                disabled={
                  operacion === 1 || operacion === 3 ? true : deshabilitado
                }
                id="multas-tab"
                data-bs-toggle="tab"
                data-bs-target="#multas"
                type="button"
                role="tab"
                aria-controls="multas"
                aria-selected="false"
              >
                Deudas del Contribuyente
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-500 text-light"
                disabled={
                  operacion === 1 || operacion === 3 ? true : deshabilitado
                }
                id="relacion-tab"
                data-bs-toggle="tab"
                data-bs-target="#relacion"
                type="button"
                role="tab"
                aria-controls="relacion"
                aria-selected="false"
              >
                Historico de Pagos
              </a>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="tributarios"
              role="tabpanel"
              aria-labelledby="datosTributarios"
            >
              <div className="col-12 m-0 p-0 d-flex flex-wrap">
                <div className="col-3 m-0 p-0">
                  <Input label = 'Código:'
                    disabled
                    ref={txtId}
                    defaultValue={
                      props.comercio
                        ? props.comercio.idcomercio !== null
                          ? props.comercio.idcomercio.trim()
                          : ""
                        : ""
                    }
                    id="inputCodigo"
                  />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input label = 'N° RITM:'
                    disabled
                    ref={txtRitm}
                    defaultValue={
                      props.comercio
                        ? props.comercio.ritm !== null
                          ? props.comercio.ritm.trim()
                          : ""
                        : ""
                    }
                    id="inputRitm"
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input label = 'Permiso N°:'
                    disabled={operacion === false ? true : false}
                    ref={txtPermiso}
                    defaultValue={
                      props.comercio
                        ? props.comercio.permiso !== null
                          ? props.comercio.permiso.trim()
                          : ""
                        : ""
                    }
                    id="inputRitm"
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input label = 'Licencia N°:'
                    disabled={operacion === false ? true : false}
                    ref={txtLicencia}
                    defaultValue={
                      props.comercio
                        ? props.comercio.numerolicencia !== null
                          ? props.comercio.numerolicencia.trim()
                          : ""
                        : ""
                    }
                    id="inputRitm"
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
                <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                  <legend className="float-none w-auto">
                    Datos del Contribuyente
                  </legend>
                  <div className="col-2 m-0 mb-2 p-0">
                    <Input label = 'Rif:'
                      disabled
                      ref={txtRif}
                      defaultValue={
                        props.comercio
                          ? props.comercio.rif !== null
                            ? props.comercio.rif.trim()
                            : ""
                          : ""
                      }
                      id="inputRitm"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                  <div className="col-6 m-0 mb-2 ml-auto p-0 pl-2">
                    <Input label = 'Denomicacion Comercial:'
                      disabled
                      ref={txtDenominacion}
                      defaultValue={
                        props.comercio
                          ? props.comercio.nombre !== null
                            ? props.comercio.nombre.trim()
                            : ""
                          : ""
                      }
                      id="inputRitm"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                  <div className="col-2 m-0 mb-2 p-0 pl-2">
                    <Input label = 'N° Telefono:'
                      disabled
                      ref={txtTlf}
                      defaultValue={
                        props.comercio
                          ? props.comercio.telefono !== null
                            ? props.comercio.telefono.trim()
                            : ""
                          : ""
                      }
                      id="inputRitm"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0">
                    <Input label = 'Fecha Inscrip:'
                      type="date"
                      disabled
                      ref={txtFechIns}
                      defaultValue={
                        props.comercio
                          ? props.comercio.fechainscripcion !== null
                            ? moment.utc(
                                props.comercio.fechainscripcion.trim()
                              ).format("YYYY-MM-DD")
                            : ""
                          : ""
                      }
                      id="inputRitm"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                  <div className="col-12 m-0 p-0">
                    <Textarea label = 'Dirección:'
                      style={{ height: 70 }}
                      disabled
                      rows={1}
                      ref={txtDireccion}
                      id="inputDireccionContri"
                      defaultValue={
                        props.comercio
                          ? props.comercio.direccion !== null
                            ? props.comercio.direccion.trim()
                            : ""
                          : ""
                      }
                      onKeyUp={handleInputChange}
                    />
                  </div>
                </fieldset>
                <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                  <legend className="float-none w-auto ">
                    Datos del Representante
                  </legend>
                  <div className="col-2 m-0 mb-2 p-0 ">
                    <Input label = 'Cédula:'
                      disabled
                      ref={txtCedRep}
                      defaultValue={
                        props.persona
                          ? props.persona.cedula !== null
                            ? props.persona.cedula.trim()
                            : ""
                          : ""
                      }
                      id="inputRitm"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                  <div className="col-10 m-0 mb-2 p-0 pl-2">
                    <Input label = 'Apellidos y Nombres:'
                      disabled
                      ref={txtNomRep}
                      defaultValue={
                        props.persona
                          ? props.persona.nombres &&
                            props.persona.apellidos !== null
                            ? props.persona.nombres.trim() +
                              " " +
                              props.persona.apellidos.trim()
                            : ""
                          : ""
                      }
                      id="inputRitm"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                  <div className="col-12 m-0 mb-2 p-0">
                    <Textarea label = 'Dirección:'
                      style={{ height: 70 }}
                      disabled
                      rows={1}
                      ref={txtDirecRep}
                      id="inputDireccionContri"
                      defaultValue={
                        props.persona
                          ? props.persona.direccion !== null
                            ? props.persona.direccion.trim()
                            : ""
                          : ""
                      }
                      onKeyUp={handleInputChange}
                    />
                  </div>
                  <div className="col-3 m-0 p-0">
                    <Input label = 'N° Telefono:'
                      disabled
                      ref={txtTlfRep}
                      defaultValue={
                        props.persona
                          ? props.persona.tlf1 !== null
                            ? props.persona.tlf1.trim()
                            : ""
                          : ""
                      }
                      id="inputRitm"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                  <div className="col-3 m-0 p-0 pl-2">
                    <Input label = 'N° Celular:'
                      disabled
                      ref={txtcelRep}
                      defaultValue={
                        props.persona
                          ? props.persona.tlf2 !== null
                            ? props.persona.tlf2.trim()
                            : ""
                          : ""
                      }
                      id="inputRitm"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                </fieldset>
                <fieldset className="col-12 m-0 p-2 border-azul rounded">
                  <legend className="float-none w-auto m-0">
                    Distancia del Local
                  </legend>
                  <div className="col-12 m-0 mb-2 p-0 d-flex gap-2">
                    <div className="col m-0 p-0">
                      <Input label = 'Inst. Educacional:'
                        disabled={operacion === false ? true : false}
                        ref={txtEducacional}
                        defaultValue={
                          props.comercio
                            ? props.comercio.educacional !== null
                              ? formatMoneda(
                                  props.comercio.educacional
                                    .trim()
                                    .toString()
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )
                              : "0,00"
                            : "0,00"
                        }
                        id="inputRitm"
                        onKeyUp={handleInputMontoChange}
                        onBlur={handleInputMontoChange}
                      />
                    </div>
                    <div className="col m-0 p-0">
                      <Input label = 'Cuartel:'
                        disabled={operacion === false ? true : false}
                        ref={txtCuartel}
                        defaultValue={
                          props.comercio
                            ? props.comercio.cuartel !== null
                              ? formatMoneda(
                                  props.comercio.cuartel
                                    .trim()
                                    .toString()
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )
                              : "0,00"
                            : "0,00"
                        }
                        id="inputRitm"
                        onKeyUp={handleInputMontoChange}
                        onBlur={handleInputMontoChange}
                      />
                    </div>
                    <div className="col m-0 p-0">
                      <Input label = 'Inst. Penal:'
                        disabled={operacion === false ? true : false}
                        ref={txtPenal}
                        defaultValue={
                          props.comercio
                            ? props.comercio.penal !== null
                              ? formatMoneda(
                                  props.comercio.penal
                                    .trim()
                                    .toString()
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )
                              : "0,00"
                            : "0,00"
                        }
                        id="inputRitm"
                        onKeyUp={handleInputMontoChange}
                        onBlur={handleInputMontoChange}
                      />
                    </div>
                    <div className="col m-0 p-0">
                      <Input label = 'Centro Deportivo:'
                        disabled={operacion === false ? true : false}
                        ref={txtDeportivo}
                        defaultValue={
                          props.comercio
                            ? props.comercio.deportivo !== null
                              ? formatMoneda(
                                  props.comercio.deportivo
                                    .trim()
                                    .toString()
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )
                              : "0,00"
                            : "0,00"
                        }
                        id="inputRitm"
                        onKeyUp={handleInputMontoChange}
                        onBlur={handleInputMontoChange}
                      />
                    </div>
                    <div className="col m-0 p-0">
                      <Input label = 'Templo:'
                        disabled={operacion === false ? true : false}
                        ref={txtTemplo}
                        defaultValue={
                          props.comercio
                            ? props.comercio.templo !== null
                              ? formatMoneda(
                                  props.comercio.templo
                                    .trim()
                                    .toString()
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )
                              : "0,00"
                            : "0,00"
                        }
                        id="inputRitm"
                        onKeyUp={handleInputMontoChange}
                        onBlur={handleInputMontoChange}
                      />
                    </div>
                  </div>
                  <div className="col-12 m-0 p-0 d-flex gap-2">
                    <div className="col m-0 p-0">
                      <Input label = 'Correcional:'
                        disabled={operacion === false ? true : false}
                        ref={txtCorrecional}
                        defaultValue={
                          props.comercio
                            ? props.comercio.correccional !== null
                              ? formatMoneda(
                                  props.comercio.correccional
                                    .trim()
                                    .toString()
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )
                              : "0,00"
                            : "0,00"
                        }
                        id="inputRitm"
                        onKeyUp={handleInputMontoChange}
                        onBlur={handleInputMontoChange}
                      />
                    </div>
                    <div className="col m-0 p-0">
                      <Input label = 'Hospital:'
                        disabled={operacion === false ? true : false}
                        ref={txtHospital}
                        defaultValue={
                          props.comercio
                            ? props.comercio.hospital !== null
                              ? formatMoneda(
                                  props.comercio.hospital
                                    .trim()
                                    .toString()
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )
                              : "0,00"
                            : "0,00"
                        }
                        id="inputRitm"
                        onKeyUp={handleInputMontoChange}
                        onBlur={handleInputMontoChange}
                      />
                    </div>
                    <div className="col m-0 p-0">
                      <Input label = 'Carretera:'
                        disabled={operacion === false ? true : false}
                        ref={txtCarretera}
                        defaultValue={
                          props.comercio
                            ? props.comercio.carretera !== null
                              ? formatMoneda(
                                  props.comercio.carretera
                                    .trim()
                                    .toString()
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )
                              : "0,00"
                            : "0,00"
                        }
                        id="inputRitm"
                        onKeyUp={handleInputMontoChange}
                        onBlur={handleInputMontoChange}
                      />
                    </div>
                    <div className="col m-0 p-0">
                      <Input label = 'Expe.Alc. por Copas:'
                        disabled={operacion === false ? true : false}
                        ref={txtCopas}
                        defaultValue={
                          props.comercio
                            ? props.comercio.porcopas !== null
                              ? formatMoneda(
                                  props.comercio.porcopas
                                    .trim()
                                    .toString()
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )
                              : "0,00"
                            : "0,00"
                        }
                        id="inputRitm"
                        onKeyUp={handleInputMontoChange}
                        onBlur={handleInputMontoChange}
                      />
                    </div>
                    <div className="col m-0 p-0">
                      <Input label = 'Mercado:'
                        disabled={operacion === false ? true : false}
                        ref={txtMercado}
                        defaultValue={
                          props.comercio
                            ? props.comercio.mercado !== null
                              ? formatMoneda(
                                  props.comercio.mercado
                                    .trim()
                                    .toString()
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )
                              : "0,00"
                            : "0,00"
                        }
                        id="inputRitm"
                        onKeyUp={handleInputMontoChange}
                        onBlur={handleInputMontoChange}
                      />
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="deuda"
              role="tabpanel"
              aria-labelledby="deuda-tab"
            >
              <TablaIndole
                disabled={props.operacion}
                indole={props.indole}
                idcomercio={
                  props.comercio
                    ? props.comercio.idcomercio !== null
                      ? props.comercio.idcomercio
                      : "0,00"
                    : "0,00"
                }
                comercio={props.comercio !== null ? props.comercio : ""}
                onHideRenderIndole={props.onHideRenderIndole}
                onHideRenderDeu={props.onHideRenderDeu}
                desabilitar={operacion === true ? true : false}
              />
            </div>

            <div
              className="tab-pane fade"
              id="historico"
              role="tabpanel"
              aria-labelledby="hist-tab"
            >
              <TablaTributaria
                disabled={props.operacion}
                idcomercio={props.comercio ? props.comercio.idcomercio : 0}
                petro={props.petro}
                comercio={props.comercio !== null ? props.comercio : ""}
                onHideRenderDeu={props.onHideRenderDeu}
              />
            </div>

            <div
              className="tab-pane fade"
              id="multas"
              role="tabpanel"
              aria-labelledby="multas-tab"
            >
              <TablaDeudaLicores
                comercio={props.comercio}
                petro={props.petro}
                visibleF={"hidden"}
                tabDeuda={props.deuda}
                idcomercio={
                  props.comercio
                    ? props.comercio.idcomercio !== null
                      ? props.comercio.idcomercio
                      : ""
                    : ""
                }
              />
            </div>

            <div
              className="tab-pane fade"
              id="relacion"
              role="tabpanel"
              aria-labelledby="relacion-tab"
            >
              <div className="py-2">
                <TablaHistoricoLicores tabHis={props.historico} />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          onClick={actualizarLicores}
        >
          Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={salir}
        >
          Salir
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />

      <Dimmer active={activate}></Dimmer>
    </Modal>
  );
};
